import { BUTTONS, PluginSettingsIcon } from 'wix-rich-content-plugin-commons';
import { getModalStyles, decorateComponentWithProps } from 'wix-rich-content-editor-common';
import { Modals } from '../modals.js';
import VideoModal from './videoModal.js';
import { MOBILE_FULL_SCREEN_CUSTOM_STYLE, DesktopFlyOutModalStyles } from 'wix-rich-content-ui-components';
import { ExtendedSelectionModalCustomStyle, SelectionModalCustomStyle } from './selectionModalCustomStyles.js';
import { VIDEO_TYPE } from '../types.js';
import { videoModalContentStyles } from '../constants.js';
import MediaReplaceIcon from '../icons/MediaReplaceIcon.js';
import './videoSelectionInputModal.js';
import 'prop-types';
import 'react';
import 'wix-rich-content-common';
import '../style-inject.es-746bb8ed.js';
import 'react-player';
import './videoPluginService.js';
import 'lodash';
import './VideoSettings.js';
import 'classnames';
import './ControlsSection.js';
import './mediaURLInputModal.js';
import './NewVideoModal.js';
import './NewVideoInsertModal.js';
import './videoUploadModal.js';
import './NewMediaUrlInputModal.js';
import 'ricos-context';
import 'ricos-schema';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const createInlineButtons = ({
  t,
  settings,
  isMobile,
  experiments = {}
}) => {
  var _a, _b;
  const { spoilerInInlineToolbar, newVideoVerticalAndSocialModals } = experiments;
  const useNewModal = newVideoVerticalAndSocialModals == null ? void 0 : newVideoVerticalAndSocialModals.enabled;
  const icon = ((_b = (_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) == null ? void 0 : _b.replace) || MediaReplaceIcon;
  const defaultCustomStyles = (!isMobile || settings.enableCustomUploadOnMobile) && (settings.handleFileSelection || settings.handleFileUpload) ? ExtendedSelectionModalCustomStyle : SelectionModalCustomStyle;
  const newModalCustomStyles = isMobile ? MOBILE_FULL_SCREEN_CUSTOM_STYLE : __spreadProps(__spreadValues({}, DesktopFlyOutModalStyles), { content: videoModalContentStyles });
  const customStyles = useNewModal ? newModalCustomStyles : defaultCustomStyles;
  const modalsStyle = getModalStyles({
    customStyles,
    fullScreen: !!useNewModal,
    isMobile
  });
  const newModalStyles = isMobile ? modalsStyle : void 0;
  const modalStyles = useNewModal ? newModalStyles : modalsStyle;
  const spoilerButton = settings.spoiler && (spoilerInInlineToolbar == null ? void 0 : spoilerInInlineToolbar.enabled) ? [
    {
      keyName: "spoiler",
      type: BUTTONS.SPOILER,
      mobile: true
    }
  ] : [];
  const settingsButton = !(spoilerInInlineToolbar == null ? void 0 : spoilerInInlineToolbar.enabled) ? [
    {
      keyName: "settings",
      type: BUTTONS.VIDEO_SETTINGS,
      fullHeight: true,
      icon: PluginSettingsIcon,
      modalName: Modals.VIDEO_SETTINGS,
      modalStyles: getModalStyles({
        isMobile
      }),
      t,
      mobile: true,
      tooltipTextKey: "SettingsButton_Tooltip",
      settings,
      triggerSettingsBi: true,
      pluginId: VIDEO_TYPE
    }
  ] : [];
  return [
    { keyName: "sizeSmallCenter", type: BUTTONS.SIZE_SMALL_CENTER, mobile: false },
    { keyName: "sizeContent", type: BUTTONS.SIZE_CONTENT, mobile: false },
    { keyName: "sizeFullWidth", type: BUTTONS.SIZE_FULL_WIDTH, mobile: false },
    { keyName: "separator1", type: BUTTONS.SEPARATOR, mobile: false },
    { keyName: "sizeSmallLeft", type: BUTTONS.SIZE_SMALL_LEFT, mobile: false },
    { keyName: "sizeSimallRight", type: BUTTONS.SIZE_SMALL_RIGHT, mobile: false },
    { keyName: "separator2", type: BUTTONS.SEPARATOR, mobile: false },
    ...spoilerButton,
    {
      keyName: "replace",
      type: BUTTONS.EXTERNAL_MODAL,
      icon,
      modalElement: decorateComponentWithProps(VideoModal, __spreadValues({}, settings)),
      modalStylesFn: useNewModal ? ({ buttonRef }) => {
        const modalStyles2 = getModalStyles({
          customStyles,
          fullScreen: true,
          isMobile
        });
        const { top, left } = buttonRef.getBoundingClientRect();
        const modalLeft = left - 15;
        const modalTop = top > 250 ? top - 250 : top + 38;
        return __spreadProps(__spreadValues({}, modalStyles2), {
          content: __spreadProps(__spreadValues({}, modalStyles2.content), {
            top: modalTop,
            left: modalLeft,
            margin: 0,
            position: "absolute"
          })
        });
      } : void 0,
      modalStyles,
      mobile: true,
      tooltipTextKey: "ReplaceVideoButton_Tooltip",
      t
    },
    ...settingsButton,
    { keyName: "delete", type: BUTTONS.DELETE, mobile: true }
  ];
};

export { createInlineButtons as default };
//# sourceMappingURL=inline-buttons.js.map
